// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STARS_RATING_SCORE_A11Y_score = "Hodnotenie %(score)s z 5 hviezdi\u010diek";
export const STARS_RATING_SCORE_score = "%(score)s z 5";
